import { render, staticRenderFns } from "./u-btn-arrow-text-fit.vue?vue&type=template&id=2c9ce751&scoped=true&"
import script from "./u-btn-arrow-text-fit.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-text-fit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ce751",
  null
  
)

export default component.exports